import { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import api from "../services/api";
import { useToast } from '../context/ToastContext';
import { ALERTAS, SITUACAO_ALUNO } from '../utilities/constantes';
import { Divider } from 'primereact/divider';
import { useForm } from 'react-hook-form';
import { SCButton, SCDropdown, SCFieldset, SCInputTextarea, SCRadioButton } from '../components';
import { SlideMenu } from 'primereact/slidemenu';
import AjudaFormTela from './AjudaFormTela';
import Loading from '../components/Loading';
import { useAuth } from '../providers/auth';
import { format } from 'date-fns';


const AvaliacaoDissertativa = () => {
    const toast = useToast();
    const tarefa = 'AvaliacaoDissertativa';

    const { periodoSelecionado, usuario } = useAuth();
    const [desabilitaEdit, setDesabilitaEdit] = useState<boolean>(true);
    const [boletimConselhoClasse, setBoletimConselhoClasse] = useState<any>();
    // const [boletimConselhoClasseOriginal, setBoletimConselhoClasseOriginal] = useState<any>();
    const [aluno, setAluno] = useState<any>()
    const [matricula, setMatricula] = useState<any>();
    const [nome, setNome] = useState<any>();
    const [filter, setFilter] = useState<any>(null);
    const [alunos, setAlunos] = useState<any>(null);
    const [turmas, setTurmas] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const dt = useRef<any>(null);
    const menu = useRef<any>(null);

    const methods = useForm();
    const { handleSubmit, control, formState: { errors }, getValues, watch, setValue } = methods;

    const watchTurmaCodigo = watch('TurmaCodigo')
    const watchSituacao = watch('Situacao')
    const watchBimestral = watch('Bimestral')
    const bimestreRef = useRef<number | null>(null);

    const load = async () => {

        setValue('Situacao', 'M')

        const turmas = await api.get('/turmas/combo', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial
            }
        });
        if (turmas.data) {
            setTurmas(turmas.data)
        } else {
            setTurmas([])
        }
    }

    useEffect(() => {
        load();
    }, []);

    const opcoes = [
        {
            label: 'Imprimir',
            icon: 'pi pi-print',
            command: () => {
                dt.current.exportCSV();
            }
        },
        {
            label: 'Exp. para Excel',
            icon: 'pi pi-file-excel',
            command: () => {
                dt.current.exportCSV();
            }
        },
        {
            label: 'Ajuda',
            icon: 'pi pi-question-circle',
            command: () => {
                dt.current.exportCSV();
            }
        },
    ];

    const openMenu = (event: any) => {
        menu?.current?.toggle(event)
    };

    const filtroAlunos = async () => {
        setLoading(true)
        setValue('HistoricoObs', '')
        if (!watchTurmaCodigo) {
            toast.showToast({ severity: 'error', summary: 'Atenção', detail: "Seleção de Turma é obrigatória." });
            setLoading(false)
            return;
        }

        try {
            const result1 = await api.get('/alunosPeriodo/listaSituacao', {
                params: {
                    EmpresaId: periodoSelecionado?.EmpresaId,
                    Ano: periodoSelecionado?.Ano,
                    Sequencial: periodoSelecionado?.Sequencial,
                    Nome: '',
                    Turma: watchTurmaCodigo,
                    Situacao: watchSituacao ? watchSituacao : null
                }
            });

            if (result1.data) {
                setAlunos(result1.data)
            } else {
                setAlunos([])
            }

            setLoading(false)

        } catch (error) {
            toast.showToast({ severity: 'error', summary: 'Atenção', detail: "Erro na pesquisa" + error });
            setLoading(false)
        }
    }

    const editar = async (item: any) => {
        setDesabilitaEdit(false)
        setValue('Bimestral', undefined)
        setValue('ObservacaoAvaliacao', '')
        setMatricula(item.Matricula)
        setNome(item.Nome)
        setAluno(item)

        const result = await api.get('/boletimConselhoClasse', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Matricula: item.Matricula,
                Sequencial: periodoSelecionado?.Sequencial,
                Ano: periodoSelecionado?.Ano,
            },
        });

        // setBoletimConselhoClasseOriginal(result.data.length > 0 ? result.data : [])
        setBoletimConselhoClasse(result.data.length > 0 ? result.data : [])
    };

    const cancelar = () => {
        setValue('ObservacaoAvaliacao', '')
        setMatricula(null)
        setNome(null)
        setAluno(null)
        setDesabilitaEdit(true)
    }

    useEffect(() => {
        if (!watchBimestral) return;

        const observacaoAtual = getValues('ObservacaoAvaliacao');

        if (bimestreRef.current) {
            const updated = boletimConselhoClasse.map((item: any) => ({
                ...item,
                [`Observacao${bimestreRef.current}ava`]: observacaoAtual,
            }));
            setBoletimConselhoClasse(updated);
        }

        const novaObs = boletimConselhoClasse[0]?.[`Observacao${watchBimestral}ava`] || '';
        setValue('ObservacaoAvaliacao', novaObs);

        bimestreRef.current = watchBimestral;

    }, [watchBimestral]);

    const handleObservacaoBlur = () => {
        const campoObservacao = `Observacao${watchBimestral}ava`;

        setBoletimConselhoClasse((prev: any) =>
            prev.map((item: any) => ({
                ...item,
                [campoObservacao]: getValues('ObservacaoAvaliacao')
            }))
        );
    };

    const gravar = async () => {
        setLoading(true)

        if (!watchBimestral) {
            toast.showToast({ severity: 'error', summary: 'Atenção', detail: "Seleção de um Bimestre é obrigatória para gravação do registro.." });
            setLoading(false)
            return;
        }

        const campoObservacao = `Observacao${watchBimestral}ava`
        let hora = format(new Date(), 'HH:mm')

        try {

            if (boletimConselhoClasse.length > 0) {
                const update = {
                    EmpresaId: periodoSelecionado?.EmpresaId,
                    Ano: periodoSelecionado?.Ano,
                    Sequencial: periodoSelecionado?.Sequencial,
                    Matricula: aluno.Matricula,
                    AtualizacaoData: new Date(),
                    AtualizacaoHora: hora,
                    AtualizacaoOperador: usuario?.Apelido,
                    [campoObservacao]: getValues('ObservacaoAvaliacao')
                }

                await api.put(`/boletimConselhoClasse`, update);
            } else {
                const create = {
                    EmpresaId: periodoSelecionado?.EmpresaId,
                    Ano: periodoSelecionado?.Ano,
                    Sequencial: periodoSelecionado?.Sequencial,
                    Matricula: aluno.Matricula,
                    AtualizacaoData: new Date(),
                    AtualizacaoHora: hora,
                    AtualizacaoOperador: usuario?.Apelido,
                    [campoObservacao]: getValues('ObservacaoAvaliacao')
                }

                await api.post(`/boletimConselhoClasse`, create);
            }
        } catch (error: any) {
            setLoading(false)
            toast.showToast({ severity: 'error', summary: 'Atenção', detail: 'Erro ao salvar o registro' + error });
        }

        setLoading(false)
        toast.showToast({ severity: 'success', summary: 'Atenção', detail: ALERTAS.registroGravado });
        load()
    }

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <div className='flex justify-content-center align-items-center p-2 border-round-top-md text-white' style={{ backgroundColor: '#0772B3' }}>
                        <h5 className="m-0 flex flex-1 align-items-center justify-content-center">Avaliacao Dissertativa</h5>
                        <AjudaFormTela tarefa={tarefa} campo='' />
                    </div>


                    <div className='grid mt-2'>
                        <div className="col-12 md:col-4">
                            <SCDropdown
                                options={SITUACAO_ALUNO}
                                optionLabel='descricao'
                                optionValue='value'
                                name="Situacao"
                                label='Situação'
                                value={watchSituacao}
                                onChange={(e) => setValue('Situacao', e.target.value)}
                                placeholder='Selecione a Situação'
                                style={{ width: '100%' }}
                            />
                        </div>
                        <div className="col-12 md:col-4">
                            <SCDropdown
                                options={turmas}
                                optionLabel='TurmaDescricao'
                                optionValue='Codigo'
                                name="TurmaCodigo"
                                label='Turma'
                                value={watchTurmaCodigo}
                                onChange={(e) => setValue('TurmaCodigo', e.target.value)}
                                placeholder='Selecione a Turma'
                                style={{ width: '100%' }}
                            />
                        </div>
                        <div className='col-12 md:col-4 flex align-items-end justify-content-between'>
                            <Button label='Pesquisar' icon="pi pi-search" className="p-button-info p-button-outlined " type='button' onClick={filtroAlunos} />

                            <SlideMenu ref={menu} model={opcoes} popup viewportHeight={opcoes.length * 37} menuWidth={175}></SlideMenu>
                            <Button label='Opções' className='p-button-secondary' type="button" icon="pi pi-plus" onClick={openMenu}></Button>
                        </div>
                    </div>
                    <Divider />
                    {loading ? <Loading full={false} /> : (
                        <DataTable
                            size='small'
                            stripedRows
                            ref={dt}
                            value={alunos}
                            dataKey="HistoricoObservacaoId"
                            paginator
                            rows={20}
                            rowsPerPageOptions={[10, 20, 40]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="{first} a {last} de {totalRecords}"
                            globalFilter={filter}
                            emptyMessage="Nenhum registro encontrado."
                            header={null}
                            responsiveLayout="scroll">

                            <Column field="Nome" header="Nome" sortable style={{ width: 200 }} bodyStyle={{ fontSize: 12 }} />
                            <Column field="Matricula" header="Matrícula" sortable style={{ width: 90 }} bodyStyle={{ fontSize: 12 }} />
                            <Column field="SituacaoAcademica" header="Situação" sortable style={{ width: 90 }} bodyStyle={{ fontSize: 12 }} body={(rowData) => {
                                return SITUACAO_ALUNO.find(x => x.value === rowData.SituacaoAcademica)?.descricao;
                            }} />
                            <Column body={(rowData: any) => {
                                return (
                                    <div className="actions flex align-items-center justify-content-between">
                                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-info" onClick={() => editar(rowData)} />
                                    </div>
                                );
                            }} style={{ width: 40 }}
                            />
                        </DataTable>
                    )}
                </div>

                <SCFieldset legend='Avaliações' className='col-12 mt-3'>
                    <div className='grid'>
                        <div className='col-12'>
                            <div className='flex justify-content-center'>
                                <div className='col-12 text-xl text-center' style={{ color: "#0772B3" }}>
                                    <span>Aluno(a) Selecionado(a):</span> <span className='font-semibold'>{nome} - {matricula}</span>
                                </div>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='flex'>
                                <div className='col-2'>
                                    <SCRadioButton
                                        control={control}
                                        name="Bimestral"
                                        label='Bimestral 1'
                                        value={1}
                                        disabled={desabilitaEdit}
                                    />
                                </div>
                                <div className='col-2'>
                                    <SCRadioButton
                                        control={control}
                                        name="Bimestral"
                                        label='Bimestral 2'
                                        value={2}
                                        className='ml-3'
                                        disabled={desabilitaEdit}
                                    />
                                </div>
                                <div className='col-2'>
                                    <SCRadioButton
                                        control={control}
                                        name="Bimestral"
                                        label='Bimestral 3'
                                        value={3}
                                        className='ml-3'
                                        disabled={desabilitaEdit}
                                    />
                                </div>
                                <div className='col-2'>
                                    <SCRadioButton
                                        control={control}
                                        name="Bimestral"
                                        label='Bimestral 4'
                                        value={4}
                                        className='ml-3'
                                        disabled={desabilitaEdit}
                                    />
                                </div>
                                <div className='col-2'>
                                    <SCRadioButton
                                        control={control}
                                        name="Bimestral"
                                        label='Bimestral 5'
                                        value={5}
                                        className='ml-3'
                                        disabled={desabilitaEdit}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <SCInputTextarea
                                style={{ minHeight: 150, width: '100%' }}
                                control={control}
                                errors={errors}
                                name="ObservacaoAvaliacao"
                                rows={5}
                                disabled={desabilitaEdit}
                                onBlur={handleObservacaoBlur}
                            />
                        </div>
                    </div>
                    <div className="flex flex-1 justify-content-between pt-3 px-2">
                        <SCButton label="Cancelar" icon="pi pi-times" className="p-button w-auto p-button-danger p-button-outlined" type='button' onClick={cancelar} />
                        <SCButton label="Gravar" icon="pi pi-check" className="p-button w-auto p-button-success" type='button' onClick={gravar} disabled={desabilitaEdit} />
                    </div>

                </SCFieldset>
            </div>
        </div>
    );
};

export default AvaliacaoDissertativa;
